import {
  Col, Card, Input,
  CardBody, Row
} from 'reactstrap';
import { useEffect, useState } from 'react';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import { useNavigate } from 'react-router-dom';
import search from "../../../assets/images/search.png";
import statusimage from "../../../assets/images/status.png";
import rightarrow from "../../../assets/images/chevron-right.png";
import download from "../../../assets/images/download.png";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import MoveDroppedStatus from '../MoveDroppedStatus/MoveDroppedStatus';
import "./DroppedTable.css";
import { Tooltip } from "@mui/material";
import PaginationTable from '../PaginationTable';
import { useSelector, useDispatch } from "react-redux";
import * as moment from 'moment';
import InstituteAutocomplete from '../../status/ProjectTable/InstituteSearch';
import { userActions } from '../../../actions/user.actions';
import { ApplicationStatusEnum } from '../../../data';
import { handleExcelDownload } from '../../../utils/excelDownload';

import useApplicationData from '../../../hooks/useApplicationData';
import { appContextConstants } from '../../../constants/appContext.constants';
import RefreshIcon from "@mui/icons-material/Refresh";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import SourceBadge from "../../shared/SourceBadge/SourceBadge";

const DroppedTable = () => {
  const datestate = useSelector((state) => state.Datefilter?.res);
  const usersearchdefstate = useSelector((state) => state?.UserSearchDefault?.res?.data?.data);
  const usersearchinsstate = useSelector((state) => state?.UserSearchIns?.res?.data?.data);
  const [instituteResetKey, setInstituteResetKey] = useState(0);
  const dispatch = useDispatch();

  const decode = useCurrentUser();
  const user = null;
  const status = ApplicationStatusEnum.Dropped;

  const {
    tableData,
    productTypeSelected,
    currentPage,
    rowsPerPage,
    totalFetchRows,
    isLoading,
    filterDateFrom,
    filterDateTo,
    instituteId,
    instituteName,
    activePage,

    setFilterDateFrom,
    setFilterDateTo,
    setInstituteId,
    setInstituteName,

    handlePageChange,
    handleRowsPerPageChange,
    handleSearch,
    clearFilters,
  } = useApplicationData({
    status,
    user,
    dependencies: {
      datestate,
      usersearchdefstate,
      usersearchinsstate,
    },
  });
  useEffect(() => { window.addEventListener("beforeunload", () => sessionStorage.removeItem("TableFilters")); }, []);
  const valid = (current) => {
    return current.isAfter(filterDateFrom);
  };

  const navigate = useNavigate();

  const handleUser = (event) => {
    const Id = event.userId;
    const applId = event.applicationId;
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      userId: event.userId,
      coapplicantId: event.coapplicantId,
      appId: applId,
    }});

    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    dispatch(userActions.getActivity(getActivityUrl, user));

    navigate('/status/dropped/profile', {
      state: {
        id: 1,
        profileId: Id,
        applicantId: Id,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        dir: "Dropped"
      }
    });
  };

  const handleCoApp = (event) => {
    const Id = event.coapplicantId;
    const applId = event.applicationId;

    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    dispatch(userActions.getActivity(getActivityUrl, user));

    navigate('/status/dropped/profile', {
      state: {
        id: 1,
        profileId: Id,
        clickEvent: "coapp",
        applicantId: event.userId,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        dir: "Dropped"
      },
    });
  };

  const handleApplicationProfile = (currApplicationId, currUID, currCoAppId) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      userId: currUID,
      appId: currApplicationId,
      coappId: currCoAppId,
    }});

    // const urlForApplicationDetails = `/admin/application/application-profile?applicationId=${sessionStorage.getItem("appId")}`;
    // const urlForBankSelfie = `/integrations/application-profile?applicationId=${sessionStorage.getItem("appId")}`;
    // const getEmiUrl = `/emis?applicationId=${sessionStorage.getItem("appId")}`;
    // const getActivityUrl = `/audit?applicationId=${sessionStorage.getItem("appId")}`;

    // dispatch(userActions.fetchUrlforApplicationdetails(urlForApplicationDetails, user), []);
    // dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie, user), []);
    // dispatch(userActions.fetchEmiUrl(getEmiUrl, user), []);
    // dispatch(userActions.getActivity(getActivityUrl, user));

    navigate("/status/dropped/appProfile");
  };

  const handleDownloadList = () => {
    handleExcelDownload({
      status: status,
      instituteId: decode.instituteId ? decode.instituteId : instituteId,
      fromDate: filterDateFrom,
      toDate: filterDateTo,
      productType:
        productTypeSelected && productTypeSelected !== "all"
          ? Number(productTypeSelected)
          : undefined,
      user: user,
      downloadIcon: download,
      buttonId: 'downloadButton',
      buttonStyles: {
        width: '90px',
        marginLeft: '150px'
      }
    });
  };

  function formatNumberWithCommas(number) {
    return number.toLocaleString('en-IN');
  }

  if (!tableData) {
    return <div>....Loading</div>;
  }

  return (
    <Card className="card" style={{ width: "100%", height: '100%' }} >
        <CardBody>
          <div>
            <p style={{ display: 'flex', alignItems: 'center' }}>
              <img src={statusimage} alt="" />
              <span style={{ fontFamily: 'Inter-Medium', marginLeft: '10px', fontSize: '14px' }}>status</span>
              <span style={{ marginLeft: '20px', marginBottom: '3px' }}>
                <img style={{ height: "18px", width: "14px" }} src={rightarrow} alt="" />
              </span>
              <span style={{ fontFamily: 'Inter-Medium', marginLeft: '10px', fontSize: '14px', color: '#D32028' }}>Dropped</span>
            </p>
          </div>

          {/* Filters */}
          <Row>
            <div style={{ display: 'flex', flex: 'wrap' }}>
              <Col sm="12" md="10" lg="3">
                <div
                  style={{
                    height: '23px',
                    marginRight: '10px',
                    fontFamily: 'Inter',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {decode.role === "institute_admin" || decode.role === "institute_user" || decode.role === "institute_cra" ?
                    (
                      <Input
                        type="text"
                        id="userSearch"
                        value={decode.instituteName}
                        readOnly
                        disabled
                        placeholder="Merchant Name"
                        style={{
                          fontSize: '0.8vw',
                          paddingLeft: '26px',
                          fontFamily: 'Inter',
                          backgroundImage: `url(${search})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: '5px center',
                          backgroundSize: '15px 15px',
                          paddingRight: '5px',
                          borderColor: '#cccccc',
                          borderStyle: 'solid',
                          borderRadius: "5px",
                          borderWidth: '1px',
                          height: '34px',
                          marginTop: '11px'
                        }}
                      />
                    ) : (
                      <InstituteAutocomplete
                        key={instituteResetKey}
                        onInstituteSelect={(id,name) =>{ 
                          setInstituteId(id)
                          setInstituteName(name || "");
                        }}
                        defaultValue={instituteName}
                        searchIcon={search}
                        placeholder={
                          decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                            ? 'Product Type'
                            : 'Merchant Name'
                        }
                      />
                    )}
                </div>
              </Col>

              {/* From Date */}
              <Col>
                <div style={{ height: '7px', marginRight: '10px' }}>
                  <Datetime
                    key={`fromDate-${filterDateFrom || "empty"}`}
                    closeOnSelect="false"
                    id="fromDate"
                    dateFormat="DD MMM YYYY"
                    timeFormat={false}
                    value={filterDateFrom ? moment(filterDateFrom, "DD MMM YYYY") : null}
                    onChange={(event) => {
                      if (event && event.format) {
                        setFilterDateFrom(event.format('DD MMM YYYY'));
                      } else {
                        setFilterDateFrom(null);
                      }
                    }}
                    locale="en-gb"
                    inputProps={{
                      placeholder: 'From Date',
                      style: { fontFamily: 'Inter', fontSize: "14px" }
                    }}
                  />
                </div>
              </Col>

              {/* To Date */}
              <Col>
                <div style={{ height: '7px', marginRight: '10px' }}>
                  <Datetime
                    key={`toDate-${filterDateTo || "empty"}`}
                    closeOnSelect="false"
                    id="toDate"
                    dateFormat="DD MMM YYYY"
                    isValidDate={valid}
                    timeFormat={false}
                    locale="en-gb"
                    initialViewDate={
                      filterDateFrom
                        ? moment(filterDateFrom, 'DD MMM YYYY')
                        : moment()
                    }
                    onChange={(event) => {
                      if (event && event.format) {
                        setFilterDateTo(event.format('DD MMM YYYY'));
                      } else {
                       setFilterDateTo(null)
                      }
                    }}
                    value={filterDateTo ? moment(filterDateTo, "DD MMM YYYY") : null}
                    inputProps={{
                      placeholder: 'To Date',
                      style: { fontFamily: 'Inter', fontSize: "14px" }
                    }}
                  />
                </div>
              </Col>

              {/* Search button */}
              <Col>
                <div>
                  <button
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '130px',
                      backgroundColor: '#D22129',
                      height: '34px',
                      borderStyle: 'none',
                      borderRadius: "5px",
                      color: 'white',
                      fontFamily: "Inter",
                      paddingLeft: '10px'
                    }}
                    onClick={handleSearch}
                  >
                    Search Results
                  </button>
                </div>
              </Col>
              <Col>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <button
                    onClick={() => {
                      clearFilters();
                      setInstituteResetKey((prev) => prev + 1);
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "34px",
                      width: "42px",
                      backgroundColor: "#D22129",
                      border: "none",
                      borderRadius: "5px",
                      color: "white",
                      cursor: "pointer",
                      marginLeft:'-20px'
                    }}
                  >
                    <RefreshIcon />
                  </button>
                </div>
              </Col>
              {/* Export */}
              {(decode.role === "cra" || decode.role === "crsa" || decode.role === "institute_cra" ||
                (decode.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e" && decode.role === "institute_user"))
                ? null
                : (
                  <Col>
                    <button
                      style={{
                        backgroundColor: '#D22129',
                        width: '90px',
                        height: '34px',
                        padding: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: "150px",
                        borderStyle: 'none',
                        borderRadius: "5px",
                        color: 'white',
                        fontFamily: "Inter"
                      }}
                      id="downloadButton"
                      onClick={handleDownloadList}
                    >
                      <p style={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
                        <img
                          style={{ height: '15px', alignItems: "center", marginRight: '5px' }}
                          src={download}
                          alt="download"
                        />
                        <span>Export</span>
                      </p>
                    </button>
                  </Col>
                )}
            </div>
          </Row>

          {/* Table / Loader */}
          {isLoading ? (
            <Box
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '15%',
                backgroundColor: 'white',
                height: '100vh'
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              <div className="tables" style={{ marginTop: '20px' }}>
                <table hover>
                  <thead className='table-heading'>
                    <tr>
                      <th
                        style={{ fontSize: '14px', fontFamily: "Inter", width: '15em', borderTopLeftRadius: '8px' }}
                        id="appId"
                      >
                        <span style={{ marginLeft: '10px' }}></span>Appl. Id
                      </th>
                      <th
                        style={{ fontSize: '14px', fontFamily: "Inter", width: '15%' }}
                        id="appname"
                      >
                        <span style={{ marginLeft: '10px' }}></span>Appl. Name
                      </th>
                      {(decode.role === "institute_user" || decode.role === "institute_admin" || decode.role === "channel_user") &&
                        decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" && (
                          <th
                            style={{ fontSize: '14px', fontFamily: "Inter", width: '10em' }}
                            id="appname"
                          >
                            <span style={{ marginLeft: '10px' }}></span>Student Name
                          </th>
                        )}
                      <th
                        style={{ fontSize: '14px', fontFamily: "Inter", width: '10em' }}
                        id="insName"
                      >
                        <span style={{ marginLeft: '10px' }}></span>
                        {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                          ? 'Product Type'
                          : 'Merchant Name'}
                      </th>
                      <th
                        style={{ fontSize: '14px', fontFamily: "Inter", width: '10em' }}
                        id="coursename"
                      >
                        <span style={{ marginLeft: '10px' }}></span>
                        {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                          ? 'Client'
                          : 'Course'}
                      </th>
                      <th
                        style={{ fontSize: '14px', fontFamily: "Inter" }}
                        id="appfromdate"
                      >
                        <span style={{ marginLeft: '10px', width: '18em' }}></span>Date
                      </th>
                      <th
                        style={{ fontSize: '14px', fontFamily: "Inter" }}
                        id="amt"
                      >
                        <span style={{ marginLeft: '10px' }}></span>Amount
                      </th>
                      {decode.role === "institute_user" ||
                      decode.role === "institute_admin" ||
                      decode.role === "user" ||
                      decode.role === "co_lender" ||
                      decode.role === "channel_user"
                        ? (
                          <th
                            id="remarks"
                            style={{ width: '6em', fontSize: '14px', fontFamily: "Inter" }}
                          >
                            Remarks
                          </th>
                        ) : (
                          <th
                            id="actions"
                            className="thead-text"
                            style={{ width: '6em', fontSize: '1vw', fontFamily: "Inter" }}
                          >
                            Actions
                          </th>
                        )}
                    </tr>
                  </thead>

                  {tableData.map((item) => (
                    <tbody className="table-body" key={item.applicationId}>
                      <tr className='table-row' style={{ lineHeight: '14px' }}>
                        {/* Appl Id */}
                        {decode.role !== "institute_user" &&
                        decode.role !== "institute_admin" &&
                        decode.role !== "channel_user" ? (
                          <td
                            onClick={() =>
                              handleApplicationProfile(
                                item.applicationId,
                                item.userId,
                                item.coapplicantId
                              )
                            }
                            style={{
                              cursor: 'pointer',
                              fontSize: '14px',
                              fontWeight: '500',
                              width: '8em',
                             color:'#667085',
                             lineHeight:'1.4em',
                              fontFamily: "Inter",
                              paddingLeft: '10px'
                            }}
                          >
                            {item.applicationId}
                          </td>
                        ) : (
                          <td
                            style={{
                              fontSize: '14px',
                              fontWeight: '500',
                              width: '8em',
                              color: '#101828',
                              fontFamily: "Inter"
                            }}
                          >
                            {(decode.role === "institute_user" &&
                              decode.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e") ? (
                              <Tooltip
                                title={item.studentId ? item.studentId : "No StudentId"}
                                arrow
                              >
                                {item.applicationId}
                              </Tooltip>
                            ) : (
                              <>{item.applicationId}</>
                            )}
                          </td>
                        )}

                        {/* Name / Coapp */}
                        {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "channel_user" ? (
                          <td
                            style={{
                              color: '#101828',
                              fontSize: '13px',
                              fontFamily: 'Inter'
                            }}
                          >
                            <span
                              title={item.name}
                              style={{
                                width: '18em',
                                fontSize: '14px',
                                lineHeight: '1.5em',
                                fontFamily: 'Inter',
                                display: "inline-block",
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                 color:'#667085',
                             lineHeight:'1.4em',
                              }}
                            >
                              {item?.name?.toLowerCase().split(' ').map(word =>
                                word.charAt(0).toUpperCase() + word.slice(1)
                              ).join(' ')}
                            </span>
                            <br />
                            {item.coapplicantName && (
                              <span
                                title={item.coapplicantName}
                                style={{
                                  width: '18em',
                                  lineHeight: '2em',
                                  fontSize: '14px',
                                  fontFamily: 'Inter',
                                  display: "inline-block",
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                   color:'#667085',
                             lineHeight:'1.4em',
                                }}
                              >
                                {item?.coapplicantName?.toLowerCase().split(' ').map(word =>
                                  word.charAt(0).toUpperCase() + word.slice(1)
                                ).join(' ')}{" "}
                                ( C )
                              </span>
                            )}
                          </td>
                        ) : (
                          <td
                            style={{
                              fontSize: '14px',
                              color: '#101828',
                              cursor: 'pointer',
                              fontFamily: "Inter"
                            }}
                          >
                            <span
                              title={item.name}
                              style={{
                                width: '18em',
                                fontFamily: "Inter",
                                lineHeight: '1.5em',
                                fontSize: '14px',
                                display: "inline-block",
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                 color:'#667085',
                             lineHeight:'1.4em',
                              }}
                              onClick={() => handleUser(item)}
                            >
                              {item?.name?.toLowerCase().split(' ').map(word =>
                                word.charAt(0).toUpperCase() + word.slice(1)
                              ).join(' ')}
                            </span>
                            <br />
                            {item.coapplicantName && (
                              <span
                                title={item.coapplicantName}
                                style={{
                                  width: '18em',
                                  fontFamily: "Inter",
                                  lineHeight: '2em',
                                  fontSize: '14px',
                                  display: "inline-block",
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                   color:'#667085',
                             lineHeight:'1.4em',
                                }}
                                onClick={() => handleCoApp(item)}
                              >
                                {item?.coapplicantName?.toLowerCase().split(' ').map(word =>
                                  word.charAt(0).toUpperCase() + word.slice(1)
                                ).join(' ')}{" "}
                                ( C )
                              </span>
                            )}
                          </td>
                        )}

                        {/* Student Name */}
                        {(decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user") &&
                        decode.instituteId === "0f25fafd-77c0-4c05-9f1-1b238f5eebd3" && (
                          <td title={item.studentName}>
                            <span
                              style={{
                                width: '10em',
                                fontWeight: '400',
                                fontSize: '14px',
                                color: '#667085',
                                fontFamily: "Inter",
                                display: "block",
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                              }}
                            >
                              {item.studentName ? item.studentName : "-"}
                            </span>
                          </td>
                        )}

                        {/* Institute */}
                        <td>
                          <div className="merchant-with-source">
                          <span
                            title={item.instituteName}
                            style={{
                              fontSize: '14px',
                              maxWidth: '10em',
                              color: '#667085',
                              fontFamily: "Inter",
                              lineHeight: '1.5em',
                              display: "inline-block",
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            {item.instituteName ? item.instituteName : '-'}
                          </span>
                          {item.productType === 2 && (
                            <SourceBadge attribution={item.attribution} repeat={item.repeat} />
                          )}
                          </div>
                        </td>

                        {/* Course / Client */}
                        <td title={item.courseName}>
                          <span
                            style={{
                              width: '10em',
                              fontSize: '14px',
                              color: '#667085',
                              fontFamily: "Inter",
                              lineHeight: '1.5em',
                              display: "inline-block",
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            {item.courseName ? item.courseName : '-'}
                          </span>
                        </td>

                        {/* Date */}
                        <td
                          title={item.applicationDate?.substr(10, 14)}
                          style={{
                            width: '14em',
                            fontSize: '14px',
                            color: '#667085',
                            fontFamily: "Inter"
                          }}
                        >
                          {item.applicationDate?.substr(0, 10)
                            ? moment(item.applicationDate?.substr(0, 10)).format('DD MMM YY')
                            : '-'}
                        </td>

                        {/* Amount */}
                        <td
                          style={{
                            fontSize: '14px',
                            width: '10em',
                            color: '#667085',
                            fontFamily: "Inter"
                          }}
                        >
                          {item.courseFees
                            ? <>&#8377;{formatNumberWithCommas(item.courseFees)}</>
                            : '-'}
                        </td>

                        {/* Remarks / Action */}
                        {decode.role === "institute_user" ||
                        decode.role === "institute_admin" ||
                        decode.role === "user" ||
                        decode.role === "co_lender" ||
                        decode.role === "channel_user" ? (
                          <td
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              justifyContent: 'center',
                              height: '6em',
                              fontFamily: 'Inter',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              position: 'relative',
                              whiteSpace: 'wrap',
                              cursor: 'pointer'
                            }}
                          >
                            <span title={item.notes ? item.notes : '-'}>
                              {item.notes ? item.notes : '-'}
                            </span>
                          </td>
                        ) : (
                          <td>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                              }}
                            >
                              <span title="Move Status" style={{ cursor: 'pointer' }}>
                                <MoveDroppedStatus ApplicantId={item} />
                              </span>
                            </div>
                          </td>
                        )}
                      </tr>
                    </tbody>
                  ))}
                </table>
              </div>

              {/* Pagination + rows per page */}
              {usersearchinsstate ? null : (
                <>
                  {totalFetchRows ? (
                    (totalFetchRows <= 10 || (filterDateFrom && filterDateTo && totalFetchRows <= 10)) ? (
                      <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                        <div
                          style={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            fontFamily: "Inter",
                            fontSize: '1vw',
                            marginLeft: '10px',
                            marginBottom: '5px'
                          }}
                        >
                          Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-
                          {currentPage * rowsPerPage - rowsPerPage + tableData?.length}{" "}
                          records of {totalFetchRows} |
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          &nbsp;<p style={{ fontWeight: '600' }}>Rows Per Pages :</p>
                          <div>
                            <span
                              onClick={() => handleRowsPerPageChange(15)}
                              style={{
                                cursor: 'pointer',
                                padding: '10px',
                                color: activePage === 15 ? "#D32028" : "black",
                                backgroundColor: activePage === 15 ? "#FFF2F3" : "",
                                borderRadius: '8px'
                              }}
                            >
                              15
                            </span>
                            <span
                              onClick={() => handleRowsPerPageChange(50)}
                              style={{
                                cursor: 'pointer',
                                padding: '10px',
                                color: activePage === 50 ? "#D32028" : "black",
                                backgroundColor: activePage === 50 ? "#FFF2F3" : "",
                                borderRadius: '8px'
                              }}
                            >
                              50
                            </span>
                            <span
                              onClick={() => handleRowsPerPageChange(100)}
                              style={{
                                cursor: 'pointer',
                                padding: '10px',
                                color: activePage === 100 ? "#D32028" : "black",
                                backgroundColor: activePage === 100 ? "#FFF2F3" : "",
                                borderRadius: '8px'
                              }}
                            >
                              100
                            </span>
                            <span
                              onClick={() => handleRowsPerPageChange(500)}
                              style={{
                                cursor: 'pointer',
                                padding: '10px',
                                color: activePage === 500 ? "#D32028" : "black",
                                backgroundColor: activePage === 500 ? "#FFF2F3" : "",
                                borderRadius: '8px'
                              }}
                            >
                              500
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                        <div
                          style={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            justifyContent: "space-between",
                            fontFamily: "Inter-Medium",
                            fontSize: '1vw',
                            marginLeft: '10px',
                            marginBottom: '5px',
                            marginRight: '10px'
                          }}
                        >
                          Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-
                          {currentPage * rowsPerPage - rowsPerPage + tableData?.length}{" "}
                          records of {totalFetchRows} |
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <p style={{ fontWeight: '600' }}>Rows Per Pages :</p>
                          <div>
                            <span
                              onClick={() => handleRowsPerPageChange(15)}
                              style={{
                                cursor: 'pointer',
                                padding: '10px',
                                color: activePage === 15 ? "#D32028" : "black",
                                backgroundColor: activePage === 15 ? "#FFF2F3" : "",
                                borderRadius: '8px'
                              }}
                            >
                              15
                            </span>
                            <span
                              onClick={() => handleRowsPerPageChange(50)}
                              style={{
                                cursor: 'pointer',
                                padding: '10px',
                                color: activePage === 50 ? "#D32028" : "black",
                                backgroundColor: activePage === 50 ? "#FFF2F3" : "",
                                borderRadius: '8px'
                              }}
                            >
                              50
                            </span>
                            <span
                              onClick={() => handleRowsPerPageChange(100)}
                              style={{
                                cursor: 'pointer',
                                padding: '10px',
                                color: activePage === 100 ? "#D32028" : "black",
                                backgroundColor: activePage === 100 ? "#FFF2F3" : "",
                                borderRadius: '8px'
                              }}
                            >
                              100
                            </span>
                            <span
                              onClick={() => handleRowsPerPageChange(500)}
                              style={{
                                cursor: 'pointer',
                                padding: '10px',
                                color: activePage === 500 ? "#D32028" : "black",
                                backgroundColor: activePage === 500 ? "#FFF2F3" : "",
                                borderRadius: '8px'
                              }}
                            >
                              500
                            </span>
                          </div>
                        </div>
                      </div>
                    )
                  ) : (
                    <div
                      style={{
                        textAlign: 'center',
                        fontWeight: 'bold',
                        fontFamily: "Inter",
                        fontSize: '14px'
                      }}
                    >
                      No Records
                    </div>
                  )}

                  <PaginationTable
                    startPage={currentPage}
                    rowsPerPage={rowsPerPage}
                    totalRows={totalFetchRows}
                    paginate={handlePageChange}
                    filterDateFrom={filterDateFrom}
                  />
                </>
              )}
            </>
          )}
        </CardBody>
    </Card>
  );
};

export default DroppedTable;
